<template>
    <a :href="internalRoute" v-html="text" />
</template>

<script>
import { mapState } from 'vuex'
import { queryEntryCTF } from '../../../plugins/contentful'

export default {
  name: 'CtfRichTextLink',
  props: {
    sysId: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      internalRoute: '#'
    }
  },
  computed: {
    ...mapState({ siteConfig: state => state.site.siteConfig })
  },
  async created () {
    const sitePage = this.siteConfig.pages.find(
      l => l.id === this.sysId
    )
    if (sitePage) {
      this.internalRoute = sitePage.route
    } else {
      const url = window.location.origin
      const page = await queryEntryCTF(this.sysId)
      if (page) {
        this.internalRoute = url + '/' + encodeURIComponent(page.fields.name.replace(/\s/g, '-').toLowerCase())
      } else {
        throw new Error('404. Page not found')
      }
    }
  }
}
</script>
